/** @jsxImportSource @emotion/react */
import React from "react";
import { Link, LinkProps } from "react-router-dom";
import { StyledText } from "../../assets/typography/typography";
import { SerializedStyles, css } from "@emotion/react";

type Props = {
  to: string;
  children: React.ReactNode;
  icon: React.ReactNode;
  additionalStyles?: SerializedStyles;
} & LinkProps &
  React.RefAttributes<HTMLAnchorElement>;

export const menuItemStyle = css`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  width: 100%;
  text-decoration: none !important;
  border: none;
  background-color: transparent;
  cursor: pointer;
  padding: 0px;
`;

export const menuIconStyle = css`
  display: flex;
  width: 24px;
  min-width: 24px;
  height: 24px;
  min-height: 24px;
  align-items: center;
  justify-content: center;
`;

export const DropdownItemLink = ({
  children,
  additionalStyles,
  icon,
  to,
  ...rest
}: Props) => {
  const extendedMenuItemStyle = css`
    ${menuItemStyle}
    ${additionalStyles}
  `;

  return (
    <Link to={to} css={extendedMenuItemStyle} {...rest}>
      <div css={menuIconStyle}>{icon}</div>
      <StyledText className="bodyTextSemibold mb-0">{children}</StyledText>
    </Link>
  );
};
